import api from '../http-common';

const edit = () =>
  api.post('/settings/climate-program/edit');

const update = (data) =>
  api.post('/settings/climate-program/update', data);

const getFile = (data) =>
  api.post('/settings/climate-program/get-file', data);

export const KlimaProgramService = {
  edit,
  update,
  getFile
};
